import { render, staticRenderFns } from "./dataPush.vue?vue&type=template&id=90a93548&scoped=true&"
import script from "./dataPush.vue?vue&type=script&lang=js&"
export * from "./dataPush.vue?vue&type=script&lang=js&"
import style1 from "./dataPush.vue?vue&type=style&index=1&id=90a93548&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a93548",
  null
  
)

export default component.exports